import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'range-question',
  templateUrl: './range-question.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./range-question.component.less']
})
export class RangeQuestionComponent implements OnInit {
  @Input() question: any;
  @Output() answered: EventEmitter<any> = new EventEmitter();
  @Output() answerCleared: EventEmitter<any> = new EventEmitter();
  @Output() modified: EventEmitter<any> = new EventEmitter();
  hasAnswer: boolean = false;
  naAnswered: boolean = false;

  ngOnInit() {
    if (!this.question.rows[0].value && this.question.rows[0].value !== 0) {
      if(this.question.slider) {
        this.question.rows[0].value = this.question.max / 2;
      } else {
        this.question.rows[0].value = "";
      }
    } else {
      this.hasAnswer = true;
      this.validate();
    }
  }

  onChange() {
    if (!this.hasAnswer) {
      this.hasAnswer = true;
      this.answered.emit(null);
    }
    if (!this.question.slider) {
      // if user deselects n/a reset hasAnswer
      if (this.question.rows[0].value === "" && this.hasAnswer) {
        this.hasAnswer = false;
        this.answerCleared.emit(null);
      }
    }
    this.validate();
    this.modified.emit(null);
  }

  validate() {
    // check if point value entered is valid input for number input
    if (this.question.rows[0].value > this.question.max) {
      this.question.rows[0].error = 'Answer can not exceed max points.';
    } else if (this.question.rows[0].value < this.question.min) {
      this.question.rows[0].error = 'Answer can not be a negative value.';
    } else {
      this.question.rows[0].error = '';
    }
  }

  naSelected(row) {
    if (row.value) {
      this.naAnswered = true;
      this.question.rows[0].value = null;
    } else {
      this.naAnswered = false;
      this.question.rows[0].value = "";
    }
    this.onChange();
  }
}



// WEBPACK FOOTER //
// ./src/app/survey/range-question/range-question.component.ts